/*
 * @Author: Teemo Ding
 * @Date: 2022-04-26 17:04:02
 * @LastEditTime: 2022-04-26 17:05:26
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Analytics/ReportingDashboard/config.ts
 */
export const breadcrumbData = ({ getI18n }) => [
  {
    url: '',
    name: getI18n('general.sider.home'),
  },
  {
    url: '',
    name: getI18n('general.sider.analytics'),
  },
  {
    url: '',
    name: getI18n('general.sider.dashboard'),
  },
];
